import {
  BarChart3,
  Brain,
  Settings,
  MessageSquare,
  Mic,
  FileText,
  PackageSearch,
  ShieldAlert,
  ClipboardList,
  Sparkles,
  LayoutGrid,
  GitMerge,
} from "lucide-react";
import theme from "../theme";

export const features = [
  {
    icon: (
      <BarChart3
        size={24}
        color={theme.colors.primary}
        aria-label="AI Backlog Icon"
      />
    ),
    title: "AI assisted work backlog generation",
    description: "Plan and track projects with AI-powered backlog management.",
  },
  {
    icon: (
      <Settings
        size={24}
        color={theme.colors.primary}
        aria-label="Custom Workflow Icon"
      />
    ),
    title: "Custom and domain specific project workflows",
    description: "Define workflows tailored to your project's unique needs.",
  },
  {
    icon: (
      <MessageSquare
        size={24}
        color={theme.colors.primary}
        aria-label="Chat Reporting Icon"
      />
    ),
    title: "Chat based reporting",
    description: "Generate reports and insights with simple chat commands.",
  },
  {
    icon: (
      <Mic
        size={24}
        color={theme.colors.primary}
        aria-label="Voice Interaction Icon"
      />
    ),
    title: "Voice enabled interaction",
    description:
      "Use voice commands to navigate and manage tasks effortlessly.",
  },
  {
    icon: (
      <FileText
        size={24}
        color={theme.colors.primary}
        aria-label="Document Management Icon"
      />
    ),
    title: "Project Based Document Management",
    description:
      "Store and manage documents for each project with desired access control.",
  },
  {
    icon: (
      <Brain
        size={24}
        color={theme.colors.primary}
        aria-label="AI Insights Icon"
      />
    ),
    title: "AI powered insights and risk management",
    description: "Leverage AI to identify risks and optimize decision-making.",
  },
];

export const titleFeatures = [
  {
    icon: (
      <PackageSearch
        size={24}
        color={theme.colors.primary}
        aria-label="Real-time delivery visibility Icon"
      />
    ),
    title: "Real-time delivery visibility",
  },
  {
    icon: (
      <ShieldAlert
        size={24}
        color={theme.colors.primary}
        aria-label="Predictive risk alerts"
      />
    ),
    title: "Predictive risk alerts",
  },
  {
    icon: (
      <ClipboardList
        size={24}
        color={theme.colors.primary}
        aria-label="Automated executive reporting"
      />
    ),
    title: "Automated executive reporting",
  },
  {
    icon: (
      <Sparkles
        size={24}
        color={theme.colors.primary}
        aria-label="AI-generated summaries and insights"
      />
    ),
    title: "AI-generated summaries and insights",
  },
  {
    icon: (
      <LayoutGrid
        size={24}
        color={theme.colors.primary}
        aria-label="Portfolio-level optimization"
      />
    ),
    title: "Portfolio-level optimization",
  },
  {
    icon: (
      <GitMerge
        size={24}
        color={theme.colors.primary}
        aria-label="Cross-functional data intelligence"
      />
    ),
    title: "Cross-functional data intelligence",
  },
];
